<template>
    <div class="asc-banks pt-3">
        <div v-for="b in banks" :key="b.swift" class="asc-banks-list">
            <a
                :class="`bank-link-${b.swift}`"
                class="bank-link"
                :href="`${api_url}/app/psd2/ais/ais-redirect/${b.swift}?activeCompany=${activeCompany}`"
                target="_blank"
                :id="b.swift"
            >
                <div style="text-align: center">
                    <img :alt="`${b.name}_logo`" :src="`${assets_url}/img/banks/${b.swift}.svg`"/>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import settings from "@/settings";

export default {
    name: "consent-banks",
    data() {
        return {
            assets_url: settings.assets_url,
            api_url: settings.api_url,
        }
    },
    computed: {
        ...mapState("ais", ["banks", "activeCompany"])
    },
}
</script>

<style scoped lang="scss">
.asc-banks {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-evenly;
    &-list img {
        width: 130px;
        height: 34px;
        border-radius: 5px;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
    }
}
</style>